module.exports = __webpack_public_path__ + "img/image_section2.99ba66a2.png";